module.exports = __webpack_public_path__ + "teaching.jpg?9f677faec5e508991fdb51ce0e573c1f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teaching.jpg
// module id = 52
// module chunks = 0